"use strict";

class remoteAPI {

	constructor(baseUrl, token) {
		this.baseUrl = baseUrl;
		if(token) this.token = token;
		if(this.baseUrl[this.baseUrl.length - 1] != '/') this.baseUrl += '/';
		this.endpoints = {
			events : this.baseUrl + 'auth/events',
			login : this.baseUrl + 'login',
			logout : this.baseUrl + 'auth/logout',
			conf : this.baseUrl + 'auth/conf',
			applications : this.baseUrl + 'auth/applications',
			searchCandidate : this.baseUrl + 'auth/searchCandidate',
			downloadCv : this.baseUrl + 'auth/getFile'
		}
		this.tokenUpdatedFn = [];
	}

	/* Send login request
	 * return promise
	 * client : str, client name
	 * token : str, master token
	 * cb : callback(err, token)
	 */
	login(client, token, cb) {
		const self = this;
		return new Promise(function(resolve, reject){
			const xmlrq = new XMLHttpRequest();
			self._bindOutput(xmlrq, function(err, res){
				let error, result;
				if(this.json){
					if(typeof(this.json.token) == 'string') result = this.json.token;
					else if(typeof(this.json.error) == 'string') error = new Error(this.json.error);
					else error = new Error('Invalid informations');
				} else error = new Error('Unable to login');
				if(error) remoteAPI._promiseSugarReject(reject, cb, error);
				else remoteAPI._promiseSugarAccept(resolve, cb, result);
			});
			xmlrq.open('POST', self.endpoints.login);
			self._buildHeaders(xmlrq, {'Content-Type' : 'application/json'});
			xmlrq.send(JSON.stringify({client : client, token : token}));
		});
	}

	/* Send logout request
	 * return promise
	 * cb : callback(err)
	 */
	logout(cb) {
		const self = this;
		return new Promise(function(resolve, reject){
			const xmlrq = new XMLHttpRequest();
			self._bindOutput(xmlrq, function(err, res){
				if(err) remoteAPI._promiseSugarReject(reject, cb, err);
				else remoteAPI._promiseSugarAccept(resolve, cb);
			});
			xmlrq.open('GET', self.endpoints.logout);
			self._buildHeaders(xmlrq);
			xmlrq.send();
		});
	}

	/* Retrieve config for current client
	 * return promise
	 * cb : callback(err, config)
	 */
	conf(cb){
		const self = this;
		return new Promise(function(resolve, reject){
			const xmlrq = new XMLHttpRequest();
			self._bindOutput(xmlrq, function(err, res){
				if(this.json && (this.json.templates || this.json.offer_templates)) remoteAPI._promiseSugarAccept(resolve, cb, this.json);
				else remoteAPI._promiseSugarReject(reject, cb, new Error('Unable to load configuration'));
			});
			xmlrq.open('GET', self.endpoints.conf);
			self._buildHeaders(xmlrq);
			xmlrq.send();
		});
	}

	/* Create new event
	 * return promise
	 * cb : callback(err, [addedEvents...])
	 */
	addNewEvent(event, cb) {
		return this._eventSugar('POST', event, cb);
	}

	/* Edit/Upsert event
	 * return promise
	 * cb : callback(err, upsertedEvent)
	 */
	editEvent(event, cb) {
		return this._eventSugar('PUT', event, cb);
	}

	/* Retrieve list of open events
	 * return promise
	 * cb : callback(err, [openEvents...])
	 */
	events(cb) {
		return this._eventSugar('GET', null, cb);
	}

	/* Save new Application
	 * return promise
	 * event : obj, {_id , name} current event
	 * application : object, form answer
	 * cb : callback(err);
	 */
	addNewApplication(event, application, id, cb) {
		const self = this;
		return new Promise(function(resolve, reject){
			const xmlrq = new XMLHttpRequest();
			self._bindOutput(xmlrq, function(err, res){
				let error, result;
				if(this.json && Array.isArray(this.json)) result = this.json;
				else error = new Error('Unable to send current application');
				if(error) remoteAPI._promiseSugarReject(reject, cb, error);
				else remoteAPI._promiseSugarAccept(resolve, cb, result);
			});
			xmlrq.open('POST', self.endpoints.applications);
			self._buildHeaders(xmlrq, {'Content-Type' : 'application/json'});
			xmlrq.send(JSON.stringify({applications : [{event : event, results : application, _id : id}]}));
		});
	}

	/* Look for candidate who are marked in event
	 * return promise
	 * event : obj, {_id , name} current event
	 * candidate : str, name to look for
	 * cb : callback(err);
	 */
	searchCandidate(event, candidate, cb) {
		const self = this;
		return new Promise(function(resolve, reject){
			const xmlrq = new XMLHttpRequest();
			self._bindOutput(xmlrq, function(err, res){
				let error, result;
				if(this.json && Array.isArray(this.json)) result = this.json;
				else error = new Error('Unable to send current application');
				if(error) remoteAPI._promiseSugarReject(reject, cb, error);
				else remoteAPI._promiseSugarAccept(resolve, cb, result);
			});
			xmlrq.open('POST', self.endpoints.searchCandidate);
			self._buildHeaders(xmlrq, {'Content-Type' : 'application/json'});
			xmlrq.send(JSON.stringify({candidate : candidate, event : event._id}));
		});
	}

	downloadCv(event, file, fname, cb) {
		const self = this;
		return new Promise(function(resolve, reject){
			const xmlrq = new XMLHttpRequest();
			self._bindOutput(xmlrq, function(err, res){
				if(err) remoteAPI._promiseSugarReject(reject, cb, err);
				else remoteAPI._promiseSugarAccept(resolve, cb, this.response);
			});
			xmlrq.responseType = 'blob';
			xmlrq.open('POST', self.endpoints.downloadCv);
			self._buildHeaders(xmlrq, {'Content-Type' : 'application/json'});
			xmlrq.send(JSON.stringify({file : file, event : event._id}));
		});
	}

	/* Set token for current instance
	 * return class instance
	 * token : string used as Bearer
	 */
	setToken(token) {
		this.token = token;
		return this;
	}

	/* Apply fn when Bearer is updated
	 * return class instance
	 * fn : function called when token is updated
	 */
	onTokenUpdate(fn){
		if(typeof(fn) == 'function') this.tokenUpdatedFn.push(fn);
		return this;
	}

	//Private
	//Bind XMLHttpRequest events to user callback + parse JSON if needed
	_bindOutput(xmlrq, callback) {
		let self = this;

		xmlrq.onreadystatechange = function() {
			if(this.readyState == this.HEADERS_RECEIVED) {
				var bearer = xmlrq.getResponseHeader("authorization");
				if(bearer) {
					self.setToken(bearer);
					self.tokenUpdatedFn.forEach(fn => {
						try{fn(bearer);}catch(e){console.log(e)};
					});
				}
			}
		};

		if(typeof(callback) != 'function') return;

		xmlrq.onerror = function(event){
			callback.call(this, event);
		};

		xmlrq.onload = function(event){
			if(this.status !== 200) callback.call(this, new Error('Invalid status'), event);
			let contentType = xmlrq.getResponseHeader("Content-Type") || xmlrq.getResponseHeader("content-type");
			if(contentType && contentType.indexOf('json')) {
				try{
					let answer = this.responseText && this.responseText.length ? this.responseText : this.response;
					this.json = JSON.parse(answer);
				}catch(e){}
			}
			callback.call(this, null, event);
		};
	}

	//Set HTTP headers
	_buildHeaders(xmlrq, headersObject) {
		if(this.token) xmlrq.setRequestHeader('authorization', 'Bearer ' + this.token);
		if(headersObject){
			Object.keys(headersObject).forEach(k => {
				xmlrq.setRequestHeader(k, headersObject[k]);
			});
		}
	}

	//Factorize envents calls
	_eventSugar(queryType, params, cb) {
		const self = this;
		return new Promise(function(resolve, reject){
			const xmlrq = new XMLHttpRequest();
			self._bindOutput(xmlrq, function(err, res){
				if(this.json) remoteAPI._promiseSugarAccept(resolve, cb, this.json);
				else remoteAPI._promiseSugarReject(reject, cb, new Error('Unable to load event'));
			});
			xmlrq.open(queryType, self.endpoints.events);
			self._buildHeaders(xmlrq, {'Content-Type' : 'application/json'});
			xmlrq.send(params ? JSON.stringify({events : params}) : undefined);
		});
	}

	//Promise or callback
	static _promiseSugarAccept(resolve, callback, val){
		return callback ? callback(null, val) : resolve(val);
	}

	//Promise or callback
	static _promiseSugarReject(reject, callback, val){
		return callback ? callback(val) : reject(val);
	}
}

export default remoteAPI;



// WEBPACK FOOTER //
// ./src/libs/api.js